export default __webpack_public_path__ + "static/media/Cake.2160d581.svg";